import Cookies from 'js-cookie';
import { CURRENT_LANGUAGE } from './constants';

// 获取用户默认语言 用户切换过就会用切换后的语言
// 没有切换就是默认中文 但是目前是默认英文 会有点问题
export const getUserDefaultLanguage = () => {
  const cookieLanguage = Cookies.get(CURRENT_LANGUAGE);
  const navigatorLanguage = window.navigator.language.toLowerCase();

  let userLanguage = '';
  // 用户是否有选择过语言 优先使用选择语言
  if (cookieLanguage) {
    userLanguage = cookieLanguage.toLowerCase();
    // 浏览器默认语言
  } else if (navigatorLanguage.startsWith('zh')) {
    userLanguage = 'zh';
  } else {
    // 系统语言
    userLanguage = navigatorLanguage;
  }

  return userLanguage;
};

// 新的公开课 语言数据存在session
// 这个好像不对
export const getUserDefaultLanguageSession = (navigatorLanguage: string = '') => {
  const cookieLanguage = Cookies.get(CURRENT_LANGUAGE);

  let userLanguage = '';
  if (cookieLanguage) {
    userLanguage = cookieLanguage.toLowerCase();
  } else if (navigatorLanguage.startsWith('zh')) {
    userLanguage = 'zh';
  } else {
    userLanguage = navigatorLanguage;
  }

  return userLanguage;
};

// 设置语言 cookie 的公用方法
// 注意：必须统一 domain/path，否则线上子域名会产生多份同名 cookie 导致读取混乱
export const setLanguageCookie = (lang: 'zh' | 'en') => {
  // 清除所有可能存在的 cookie 副本（顶级域 + 当前子域名 + 无 domain 默认写入）
  Cookies.remove(CURRENT_LANGUAGE, { domain: '.wukongedu.net', path: '/' });
  Cookies.remove(CURRENT_LANGUAGE, { domain: '.wukongsch.com', path: '/' });
  Cookies.remove(CURRENT_LANGUAGE, { path: '/' });
  Cookies.remove(CURRENT_LANGUAGE);

  if (lang) {
    Cookies.set(CURRENT_LANGUAGE, lang, { path: '/' });
  }
};

// 从 URL 路径检测语言并设置 cookie
export const detectAndSetLanguageFromUrl = (defaultLang: 'zh' | 'en' = 'zh', includeRootPath: boolean = false) => {
  try {
    const currentPath = window.location.pathname;
    let detectedLang: 'zh' | 'en' = defaultLang;

    // 从 URL 路径中检测语言
    if (currentPath.includes('/zh/')) {
      detectedLang = 'zh';
    } else if (currentPath.includes('/en/')) {
      detectedLang = 'en';
    } else if (includeRootPath && currentPath === '/') {
      // FB页面特殊逻辑：根路径也算作英文
      detectedLang = defaultLang;
    }

    // 设置语言 cookie
    setLanguageCookie(detectedLang);

    console.log(`检测到页面语言: ${detectedLang}, 路径: ${currentPath}, 默认语言: ${defaultLang}`);
    return detectedLang;
  } catch (error) {
    console.warn('语言检测失败:', error);
    return defaultLang; // 出错时返回默认语言
  }
};

// 便捷方法：普通页面语言检测 (默认中文)
export const detectAndSetLanguageFromUrlDefault = () => {
  return detectAndSetLanguageFromUrl('zh', false);
};

// 便捷方法：FB页面语言检测 (默认英文，包含根路径)
export const detectAndSetLanguageFromUrlForFB = () => {
  return detectAndSetLanguageFromUrl('en', true);
};
